export default "__VITE_ASSET__Cx$$2Luz__"